import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, LoginGuard } from './guards/index';
import { AuthService } from '../shared/services/index';
import { LoginPageComponent } from './pages/login/login.page';
import { AuthWrapperComponent } from './pages/auth-wrapper/index';
import { TranslateResolver } from '../utils/translate.resolver';

const appRoutes: Routes = [
  {
    path: 'auth',
    component: AuthWrapperComponent,
    resolve: { translation: TranslateResolver },
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', canActivate: [LoginGuard], component: LoginPageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  exports: [RouterModule],
  providers: [AuthGuard, LoginGuard, AuthService]
})
export class AuthRoutingModule {}
